module.exports = __webpack_public_path__ + "img/jeans.3f6e80e5.png";